import { useEffect } from "react";

const SPACE_THEME_CLASS = "lf-h5-theme-space";

/** 空间浅色页：html/body 背景改白，避免 iOS 底部露出 #000 */
export function useDocumentSpaceTheme(enabled = true): void {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    document.documentElement.classList.add(SPACE_THEME_CLASS);
    return () => {
      document.documentElement.classList.remove(SPACE_THEME_CLASS);
    };
  }, [enabled]);
}
